<template>
    <section class="property-opendoor section-outline">
        <div class="property-opendoor-panel" >
            <div>
                <img
                    :src="glb.cdnUrl + 'vimages/opendoor_dark.svg'"
                    alt="Opendoor"
                    loading="lazy"
                />
                <span>
                    Sell your home <b class="text-bold">3x faster</b> with Opendoor. <span class="opendoor-highlight" v-if="estimateText">Est. {{ estimateText }}</span>
                </span>
            </div>
            <button v-if="opendoorAddressDetails && opendoorAddressDetails.isEligible"
                type="button"
                class="btn secondary medium"
                @click="onCta"
            >
                Get cash offer
            </button>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import  format from '@/common/utilities/format';

export default {
    name: 'propertyOpendoorPanel',
    inject: ['$eventBus'],
    props: {
        opendoorAddressDetails: {
            type: Object,
            default: null,
        },
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp']),
        estimateText() {
            if(this.getSplit('movoto-opendoor-panel-CW-4375', 'on2')){
                return '';
            }
            const estimate = this.opendoorAddressDetails && this.opendoorAddressDetails.valueEstimate;
            if (!estimate || estimate.lower == null || estimate.upper == null) {
                return '';
            }
            const lower = Number(estimate.lower);
            const upper = Number(estimate.upper);
            if (Number.isNaN(lower) || Number.isNaN(upper)) {
                return '';
            }
            const lowerK = `$${format.friendlyPrice(lower)}`;
            const upperK = `$${format.friendlyPrice(upper)}`;
            return `${lowerK}-${upperK}`;
        },
        referralUrl() {
            return '';
            // const url = this.opendoorAddressDetails && this.opendoorAddressDetails.referral && this.opendoorAddressDetails.referral.url;
            // return url || '';
        },
    },
    methods: {
        onCta() {
            this.$eventBus.$emit('property-pop-opendoor');
            this.$eventBus.$emit('ga', { ec: 'initial_cta_click', en: 'opendoor', el: 'get_cash_offer' });
        },
    },
};
</script>

<style lang="scss">
@use './property-opendoor-panel.scss' as *;
</style>
